import React, { useEffect, useMemo, useState } from "react";
import { X, Eye, Trash2, FileText } from "lucide-react";
import { PulseLoader } from "react-spinners";
import Loader from "./Loader";

const AttachmentPreview = ({ file, onRemove, isRemove = true }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);

  const isPdf = useMemo(() => {
    if (!file) return false;
    if (typeof file === "string") return file.toLowerCase().includes(".pdf");
    return file.type === "application/pdf";
  }, [file]);

  const openPreview = (file) => {
    setIsPreviewOpen(true);
    setLoading(true);

    if (typeof file === "string") {
      setPreviewUrl(file);
    } else {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    }

    setPreviewFile(file);
    setTimeout(() => setLoading(false), 400);
  };

  const closePreview = () => {
    if (previewFile && typeof previewFile !== "string" && previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setIsPreviewOpen(false);
    setPreviewFile(null);
    setPreviewUrl(null);
  };

  useEffect(() => {
    return () => {
      if (previewFile && typeof previewFile !== "string" && previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewFile, previewUrl]);

  if (!file) return null;

  return (
    <>
      {/* Attachment Row */}
      <div className="flex items-center justify-between gap-3 p-2 border rounded-lg bg-gray-50">
        <div className="flex items-center gap-2 text-sm truncate">
          {isPdf ? <FileText size={16} /> : <Eye size={16} />}
          <span className="truncate max-w-[140px]">
            {typeof file === "string" ? "Attachment" : file.name}
          </span>
        </div>

        <div className="flex gap-2">
          {/* Preview */}
          {/* <button
            onClick={() => openPreview(file)}
            className="p-1.5 rounded-md bg-blue-50 hover:bg-blue-100 text-blue-600"
            title="Preview"
          >
            <Eye size={16} />
          </button> */}
          <a
            href={typeof file === "string" ? file : URL.createObjectURL(file)}
            target="_blank"
            rel="noreferrer"
            className="p-1.5 rounded-md bg-blue-50 hover:bg-blue-100 text-blue-600"
          >
            <Eye
              size={20}
              className="text-gray-500 cursor-pointer hover:text-[#00B8D9]"
              title="View Document"
            />
          </a>

          {/* Remove */}
          {isRemove && (
            <button
              onClick={onRemove}
              className="p-1.5 rounded-md bg-red-50 hover:bg-red-100 text-red-600"
              title="Remove"
            >
              <Trash2 size={16} />
            </button>
          )}
        </div>
      </div>

      {/* Preview Modal */}
      {isPreviewOpen && (
        <div
          onClick={closePreview}
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999] p-2 sm:p-3 h-[100dvh]"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white max-w-4xl w-full rounded-2xl p-5 relative max-h-[95dvh] overflow-hidden"
          >
            {/* Close */}
            <button
              onClick={closePreview}
              className="absolute top-0 right-4 mt-2"
            >
              <X size={22} />
            </button>

            {/* Preview */}
            <div className="border rounded-xl flex justify-center bg-gray-50 w-full h-[70dvh] sm:h-[450px]">
              {loading ? (
                <Loader />
              ) : isPdf ? (
                <iframe
                  src={previewUrl}
                  className="w-full h-full rounded-xl border"
                  title="PDF Preview"
                />
              ) : (
                <img
                  src={previewUrl}
                  className="w-full h-full object-contain rounded-lg"
                  alt="Preview"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AttachmentPreview;
